var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconUserCircle = function SvgIconUserCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31.561,
    height: 31.561,
    viewBox: "0 0 31.561 31.561",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.78.562a15.78,15.78,0,1,0,15.78,15.78A15.778,15.778,0,0,0,15.78.562Zm0,6.108a5.6,5.6,0,1,1-5.6,5.6A5.6,5.6,0,0,1,15.78,6.671Zm0,21.889a12.193,12.193,0,0,1-9.322-4.34,7.094,7.094,0,0,1,6.268-3.805,1.557,1.557,0,0,1,.452.07,8.425,8.425,0,0,0,2.6.439,8.393,8.393,0,0,0,2.6-.439,1.557,1.557,0,0,1,.452-.07A7.094,7.094,0,0,1,25.1,24.22,12.193,12.193,0,0,1,15.78,28.56Z",
    transform: "translate(0 -0.563)",
    fill: "#8d8585"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconUserCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-user-circle.e53cdeb9.svg";
export { ForwardRef as ReactComponent };